import useAuth from "common/hooks/useAuth";
import MediatorDetails from 'pages/Mediators/MediatorDetails';

function MyAccount() {
  const { user: currentUser } = useAuth();
  return <MediatorDetails userId={String(currentUser?.id)} />;
}

export default MyAccount;
